import React from "react";
import { Link } from "react-router-dom";
import "./CardTask.css";
import "../../assets/style/animate.css";

import axios from "axios";
import Moment from "react-moment";

import Swal from "sweetalert2";
import "moment/locale/pt-br";
import ReactMomentCountDown from "react-moment-countdown";
//import Chat from "../chat/Chat";
import io from "socket.io-client";

//Moment.globalMoment = moment;
Moment.globalLocal = true;
//Moment.globalTimezone = "America/Sao_Paulo";

const urlSocket = process.env.REACT_APP_API_SOCKET;
const url = process.env.REACT_APP_API_TASK;

const socket = io(urlSocket);

class CardTask extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      statusTask: "bg-warning",
      id_task: this.props.id_task,
      tokenLocal: localStorage.getItem("token"),
      inicialDateMoment: "",
      inicialTimeMoment: "",
      finalDateMoment: "",
      dateTimeMoment: "",
      showTarefaPausada: false,
      alertaTarefa: "",
      chatOpen: "",
      color: "",
      modal: "",
      tecnicos: []
    };
  }

  componentDidMount() {
    this.defaultTime();
    this.socketOn();
    this.tecnicos();
  }

  tecnicos = () => {
    let tecnicos = this.props.tecnico.split(",");
    this.setState({
      tecnicos: tecnicos
    });
  };

  socketOn = () => {
    //
    socket.on(this.state.id_task, msg => {
      if (this.state.chatOpen === "close") {
        this.setState({
          color: "red"
        });
      }
    });
  }; // por uma flag quando existir nova menssagem  e quando responder a menssagem ou visualizar a menssagem de como lida
  dateNow = () => {
    var d = new Date();
    var dd = d.getDay();
    if (dd < 10) {
      dd = "0" + dd;
    }
    var yy = d.getFullYear();
    var mm = d.getMonth();
    if (mm < 10) {
      mm = "0" + mm;
    }

    return yy + "-" + mm + "-" + dd;
  };
  dateToMoment = date => {
    if (date) {
      var res = [];
      res = date.split("/");
      res = `${res[2]}-${res[1]}-${res[0]}`;
      return res;
    }
  };

  dateTolocal = date => {
    var res = [];
    res = date.split("-");
    res = `${res[2]}/${res[1]}/${res[0]}`;
    return res;
  };

  defaultTime = async () => {
    const token = localStorage.getItem("token");
    const objForm = { id_rat_pop: this.props.id_task, token: token };

    if (token) {
      const responseAtividadeTempo = await axios.post(
        `${url}/atividadesTempo`,
        {
          objForm: objForm
        }
      );

      if (responseAtividadeTempo.data.resulAtividadesTempo.length > 0) {
        if (
          responseAtividadeTempo.data.resulAtividadesTempo[0].data_final === ""
        ) {
          this.setState({
            statusTask: "bg-primary",
            dataInicial:
              responseAtividadeTempo.data.resulAtividadesTempo[0].data_inicial,
            horaInicial:
              responseAtividadeTempo.data.resulAtividadesTempo[0].hora_inicial
          });
        } else if (
          responseAtividadeTempo.data.resulAtividadesTempo[0].data_final !==
            "" &&
          responseAtividadeTempo.data.resulAtividadesTempo[0].data_inicial !==
            ""
        ) {
          this.setState({
            dataFinal:
              responseAtividadeTempo.data.resulAtividadesTempo[0].data_final,
            horaFinal:
              responseAtividadeTempo.data.resulAtividadesTempo[0].hora_final
          });
          this.setState({
            showTarefaPausada: true
          });

          if (this.props.status === "concluido") {
            this.setState({
              statusTask: "bg-success"
            });
          } else {
            this.setState({
              statusTask: "bg-danger"
            });
          }
        }
      }
    }
  };

  startTask = idTask => {
    const token = localStorage.getItem("token");
    const objForm = { id_rat_pop: idTask, token: token };

    axios
      .post(
        `${url}/inicioTask`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        socket.emit("newTask", "startDash");
        this.defaultTime();
        this.setState({
          statusTask: "bg-primary"
        });
        this.setState({
          showTarefaPausada: false
        });
      });
  };

  pauseTask = idTask => {
    Swal.fire({
      title: "Informe o motivo de pausar",
      input: "select",
      inputOptions: {
        Sem_liberação_de_acesso: "Sem liberação de acesso",
        Solicitação_do_Operacional: "Solicitação do Operacional"
      },
      inputPlaceholder: "Selecione",
      showCancelButton: true,
      inputValidator: function(value) {
        return new Promise(function(resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("Você precisa selecionar um motivo.");
          }
        });
      }
    }).then(function(result) {
      if (result.value) {
        const token = localStorage.getItem("token");
        const objForm = {
          id_rat_pop: idTask,
          token: token,
          motivo: result.value
        };
        // axios
        axios
          .post(
            `${url}/pauseTask`,
            {
              objForm: objForm
            },
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8"
              }
            }
          )
          .then(response => {
            Swal.fire({
              title: "Salvo",
              text: "Tarefa Pausada",
              icon: "success"
            }).then(result => {
              if (result) {
                socket.emit("newTask", "pauseDash");
              }
            });
          });
      }
    });
  };

  timeLastTask = target => {
    let min = Math.floor((target / 1000 / 60) << 0);

    if (this.dateNow() === this.props.dataAgendada) {
      if (min < 10 && min > 0) {
        this.setState({ alertaTarefa: "animated pulse infinite" });
      }
    }
  };

  timeEndTask = e => {
    this.setState({
      alertaTarefa: "sem_alerta",
      statusTarefa: "Não Iniciada"
    });
  };
  /*
  openChat = () => {
    if (this.state.chatOpen === "show") {
      this.setState({
        chatOpen: "close",
        modal: ""
      });
    } else {
      this.setState({
        chatOpen: "show",
        color: "",
        modal: "modal-backdrop fade show"
      });
    }
  };
 */

  arquiveTask = idTask => {
    const objForm = { idTask: idTask, token: localStorage.getItem("token") };
    Swal.fire({
      title: "Você tem certeza?",
      text: "Você vai arquivar está atividade.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar"
    }).then(result => {
      if (result.value) {
        axios
          .post(
            `${url}/postTaskArquivar`,
            {
              objForm: objForm
            },
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8"
              }
            }
          )
          .then(response => {
            if (response.data === 1) {
              Swal.fire(
                "Arquivado!",
                "Sua Atividade foi Arquivada.",
                "success"
              );
              socket.emit("newTask", "arquive");
            } else {
              Swal.fire("Não Arquivado!", "Falha ao Arquivar.", "error");
            }
          });
      }
    });
  };
  render() {
    return (
      <React.Fragment>
        <div className={` ${this.state.modal}`} />
        {/*
        {this.state.chatOpen === "show" && (
          <div className={`modal ${this.state.chatOpen} contentChat  fade`}>
            <button onClick={() => this.openChat()} className="buttonSair">
              X
            </button>
            
            <Chat
              taskId={this.props.idTaskPrincipal}
              title={this.props.title}
              chatOpen="show"
            />
           
          </div>
        )}
      */}
        <div className={`card-list ${this.state.alertaTarefa}`}>
          {/*
          <div className="leftText">
            <button onClick={() => this.openChat()}>
              <i className={`fab fa-facebook-messenger ${this.state.color} `} />
            </button>
          </div>
          */}
          <div className="card-list-head">
            <h5>{this.props.title}</h5>

            {this.state.alertaTarefa !== "sem_alerta" && (
              <div>
                <b>Faltam </b>
                <ReactMomentCountDown
                  onTick={this.timeLastTask.bind(this)}
                  toDate={`${this.props.dataAgendada} ${this.props.horaAgendada}`}
                  sourceFormatMask="YYYY-MM-DD HH:mm:ss"
                  targetFormatMask="DD "
                  onCountdownEnd={this.timeEndTask.bind(this)}
                />
                <b> Dia(s) e </b>
                <ReactMomentCountDown
                  onTick={this.timeLastTask.bind(this)}
                  toDate={`${this.props.dataAgendada} ${this.props.horaAgendada}`}
                  sourceFormatMask="YYYY-MM-DD HH:mm:ss"
                  targetFormatMask="HH:mm:ss"
                  onCountdownEnd={this.timeEndTask.bind(this)}
                />
                <b> Hora(s)</b>
              </div>
            )}
          </div>
          <span className="text-small">
            <b> Data: </b> {this.dateTolocal(this.props.dataAgendada)}
            <b> Hora: </b>
            {this.props.horaAgendada}
          </span>
          <div className="card card-task">
            <div className="progress">
              <div
                className={` 'progress-bar' + ${this.state.statusTask}`}
                role="progressbar"
                style={{ width: "50%", marginLeft: "-2px" }}
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>
            <div className="card-body">
              <div className="card-title">
                <h6 data-filter-by="text">
                  {this.props.type === "manutencao_preventiva" && (
                    <span>Manutenção Preventiva</span>
                  )}
                  {this.props.type === "manutencao_corretiva" && (
                    <span>Manutenção Corretiva</span>
                  )}
                  {this.props.type === "manutencao_emergencial" && (
                    <span>Manutenção Emergencial</span>
                  )}
                  {this.props.type === "vistoria" && <span>Vistoria</span>}
                  {this.props.type === "instalacao" && <span>Instalação</span>}
                  {this.props.type === "retirada" && <span>Retirada</span>}
                  {this.props.type === "atividade_interna" && (
                    <span>Atividade Interna</span>
                  )}
                </h6>

                {this.state.statusTask === "bg-primary" && (
                  <div>
                    <span className="text-small">
                      <b> Tarefa Iniciada: </b>
                      <Moment fromNow>{`${this.dateToMoment(
                        this.state.dataInicial
                      )}T${this.state.horaInicial}-0300`}</Moment>
                    </span>
                  </div>
                )}

                {this.state.showTarefaPausada && (
                  <React.Fragment>
                    {this.props.status === "concluido" ? (
                      <span className="text-small">
                        <b>Tarefa Concluída: Data : </b>
                        {this.state.dataFinal} <b>Hora:</b>
                        {this.state.horaFinal}
                      </span>
                    ) : (
                      <span className="text-small">
                        <b>Tarefa Pausada: Data : </b>
                        {this.state.dataFinal} <b>Hora:</b>
                        {this.state.horaFinal}
                      </span>
                    )}
                  </React.Fragment>
                )}
              </div>

              <div className="card-meta">
                <ul className="avatars">
                  {this.state.tecnicos.map((value, i) => (
                    <React.Fragment key={i}>
                      {value.replace(/\s/g, "") !== "AllNet" && (
                        <li>
                          <img
                            alt={value}
                            className="avatar"
                            style={{ width: "2.5rem", height: "2.5rem" }}
                            src={
                              url + `/tecnicos/${value.replace(/\s/g, "")}.jpg`
                            }
                          />
                        </li>
                      )}
                      {/*value
                      .match(/\b(\w)/g)
                      .join("")
                    .toUpperCase()*/}
                    </React.Fragment>
                  ))}
                </ul>
                <div className="d-flex align-items-center">
                  <span># {this.props.idTaskPrincipal}</span>
                </div>

                <div className="dropdown card-options">
                  <button
                    className="btn-options"
                    type="button"
                    id="task-dropdown-button-2"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i className="material-icons">more_vert</i>
                  </button>
                  <div className="dropdown-menu dropdown-menu-right">
                    <span className="dropdown-item">
                      <Link to={`/task-descriptions/${this.props.id_task}`}>
                        Visualizar Tarefa
                      </Link>
                    </span>
                    <div className="dropdown-divider" />
                    {this.state.statusTask !== "bg-primary" && (
                      <button
                        onClick={() => this.startTask(this.props.id_task)}
                        className="dropdown-item text-success"
                      >
                        Iniciar Tarefa
                      </button>
                    )}

                    {this.state.statusTask === "bg-primary" && (
                      <button
                        onClick={() => this.pauseTask(this.props.id_task)}
                        className="dropdown-item text-danger"
                      >
                        Pausar Tarefa
                      </button>
                    )}

                    {this.props.status === "concluido" && (
                      <button
                        onClick={() => this.arquiveTask(this.props.id_task)}
                        className="dropdown-item text-danger"
                      >
                        Arquivar
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card card-task">
            <div className="progress">
              <div
                className="progress-bar bg-primary"
                role="progressbar"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default CardTask;
